import { render, staticRenderFns } from "./RepeatMedicationModal.vue?vue&type=template&id=20575310&scoped=true&lang=pug"
import script from "./RepeatMedicationModal.vue?vue&type=script&lang=js"
export * from "./RepeatMedicationModal.vue?vue&type=script&lang=js"
import style0 from "./RepeatMedicationModal.vue?vue&type=style&index=0&id=20575310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20575310",
  null
  
)

export default component.exports